// 字典启用禁用
export enum DICTIONARY_STATUS_ENUM{
  /* 启用 */
  ENABLE = '0',
  /* 禁用 */
  DISENABLE = '1',
}

export const DICTIONARY_STATUS_LIST = [
  {
    label: '启用',
    value: DICTIONARY_STATUS_ENUM.ENABLE,
  },
  {
    label: '禁用',
    value: DICTIONARY_STATUS_ENUM.DISENABLE,
  },
];
